module.exports = __webpack_public_path__ + "static/media/wall-clock1.296dd4b6.png";